module.exports = __webpack_public_path__ + "static/media/Recent_Uploads_Icon.98463bba.svg";